import React from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Button, Paper, TableRow, Typography } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import {
  useGetPendingAdhocDistributionSummaryQuery
} from '../../../../api-services/asset-holdings/adhocDistributionApi'
import { DataGrid, type GridColDef, type GridRenderCellParams, type GridValueGetterParams } from '@mui/x-data-grid'
import { NumberFormatter } from '../../../../utility/formatters/NumberFormatter'
import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import LoadingComponent from '../../../components/ui-widgets/LoadingComponent'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import MUIDataTable from 'mui-datatables'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import {
  type AdhocCurrencyConversionDetail,
  type AdhocCurrencyConversionSummary
} from '../../../../api-schema-types/asset-holdings/AdhocDistributionCrudDtos'

const AdhocDistributionsPage: React.FC = () => {
  const history = useHistory()
  const goTo = (location: string): void => {
    history.push(location)
  }
  // const [expanded, setExpanded] = useState(false)

  const handleSetExchangeRate = (currencyConversionSummary: AdhocCurrencyConversionSummary): void => {

    // setExpanded(!expanded)
  }
  const isConversionDisabled = (conversionSummary: AdhocCurrencyConversionSummary): boolean => {
    return !(conversionSummary.amountTotal === 0 && conversionSummary.srcCurrencyId !== conversionSummary.currencyId)
    // return false
    // setExpanded(!expanded)
  }

  const getEditId = (params: GridValueGetterParams): number => {
    return params.row.currencyId
  }

  const pendingAdhocDistributionsApiResult = useGetPendingAdhocDistributionSummaryQuery({})

  const conversionSummaryGrids: GridColDef[] = [
    { field: 'srcCurrencyId', headerName: 'Source Currency Id', flex: 30, editable: true },
    { field: 'srcCurrencyCode', headerName: 'Source Currency Code', flex: 30, editable: true },
    { field: 'srcCurrency', headerName: 'Source Currency', flex: 70, editable: true },
    {
      field: 'srcAmountTotal',
      headerName: 'Source Total',
      flex: 70,
      editable: false,
      renderCell: (params: GridRenderCellParams) => {
        return <span>{NumberFormatter.roundToString(params.value, 8)}</span>
      }
    },
    { field: 'currencyId', headerName: 'Currency Id', flex: 70, editable: true, valueGetter: getEditId },
    { field: 'currencyCode', headerName: 'Currency Code', flex: 70, editable: true },
    { field: 'currency', headerName: 'Currency', flex: 70, editable: true },
    {
      field: 'amountTotal',
      headerName: 'Amount Total',
      flex: 120,
      editable: false,
      renderCell: (params: GridRenderCellParams) => {
        return <span>{NumberFormatter.roundToString(params.value, 8)}</span>
      }
    },
    {
      field: 'countAdhocInstructions',
      headerName: '# Instructions',
      flex: 30,
      editable: false
    },
    {
      field: 'editId',
      headerName: '',
      flex: 70,
      valueGetter: getEditId,
      renderCell: params => (
        <div>
          <Button variant="text" onClick={() => { handleSetExchangeRate(params.value) }} disabled={isConversionDisabled(params.row)} >
            Set Exchange Rate
          </Button>
        </div>
      )
    }
  ]

  const pendingAdhocColumns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'projectId',
      label: 'Project Id',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'projectName',
      label: 'Project',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'currencyId',
      label: 'Currency Id',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'currencyCode',
      label: 'Currency Code',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'currency',
      label: 'Currency',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'numberCellOwnerAgreements',
      label: '# COAs',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'numberOfCells',
      label: '# Cells',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'amountToDistribute',
      label: 'Amount To Distribute',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'amountPerCell',
      label: 'Amount Per Cell',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'narrative',
      label: 'Narrative',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true
      }
    }

  ]

  const options = {
    expandableRows: true,
    expandableRowsOnClick: true,
    renderExpandableRow: (rowData: string[], rowMeta: any) => {
      let instructionConversions: AdhocCurrencyConversionDetail[] = []
      if (pendingAdhocDistributionsApiResult.isSuccess) {
        instructionConversions = pendingAdhocDistributionsApiResult.data.pendingDistributions[rowMeta.dataIndex].conversions
        return (
          <React.Fragment>
            <tr>
              <td colSpan={10}>
                <TableContainer component={Paper}>
                  <Table style={{ minWidth: '650' }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>srcCurrencyId</TableCell>
                        <TableCell align="right">srcAmount</TableCell>
                        <TableCell align="right">srcCurrencyId</TableCell>
                        <TableCell align="right">srcCurrency</TableCell>
                        <TableCell align="right">srcCurrencyCode</TableCell>
                        <TableCell align="right">numberOfCells</TableCell>
                        <TableCell align="right">currencyId</TableCell>
                        <TableCell align="right">amount</TableCell>
                        <TableCell align="right">currencyId</TableCell>
                        <TableCell align="right">currency</TableCell>
                        <TableCell align="right">currencyCode</TableCell>
                        <TableCell align="right">exchangeRate</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {instructionConversions.map((conversion: AdhocCurrencyConversionDetail) => (
                        <TableRow key={conversion.id}>
                          <TableCell>{conversion.srcCurrencyId}</TableCell>
                          <TableCell align="right">{conversion.srcAmount}</TableCell>
                          <TableCell align="right">{conversion.srcCurrencyId}</TableCell>
                          <TableCell align="right">{conversion.srcCurrency}</TableCell>
                          <TableCell align="right">{conversion.srcCurrencyCode}</TableCell>
                          <TableCell align="right">{conversion.numberOfCells}</TableCell>
                          <TableCell align="right">{conversion.currencyId}</TableCell>
                          <TableCell align="right">{conversion.currency}</TableCell>
                          <TableCell align="right">{conversion.currencyCode}</TableCell>
                          <TableCell align="right">{conversion.amount}</TableCell>
                          <TableCell align="right">{conversion.exchangeRate}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </td>
            </tr>
          </React.Fragment>
        )
      }
    }
  }

  return (
    <>
    <Box sx={{ mb: 4, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <Typography variant={'h4'}>Adhoc Distribution Instructions</Typography>
      <Button variant={'text'} type="button" onClick={() => { goTo('/app/finance-area') }}>
        <HomeIcon style={{ color: '#444' }} />
      </Button>
    </Box>
      <Paper>
        <Box sx={{ p: 4, mt: 3 }}>
           {pendingAdhocDistributionsApiResult.isLoading && <LoadingComponent />}
           {(pendingAdhocDistributionsApiResult.error != null) && <ErrorComponent message={RtkQueryHelper.mapResponseError(pendingAdhocDistributionsApiResult.error)} />}
           { pendingAdhocDistributionsApiResult.isSuccess && (
                <DataGrid
                  getRowId={(row) => row.currencyId}
                  rows={pendingAdhocDistributionsApiResult.data.conversions}
                  columns={conversionSummaryGrids}
                  autoHeight={true}
                  rowCount={pendingAdhocDistributionsApiResult.data.conversions.length}
                  paginationMode="server"
                  pagination
                />

           )}
            </Box>
        {/* <Grid container spacing={4}> */}
        {/*  <Grid item md={12} sx={{ mt: 3 }}></Grid> */}
        {/*  <Grid item md={2}> */}
        {/*    <Typography variant={'body2'}>Project cells</Typography> */}
        {/*    <Typography variant={'subtitle1'}> */}
        {/*      <strong>{project.crowdSale.countProjectCells}</strong> */}
        {/*    </Typography> */}
        {/*  </Grid> */}
        {/*  <Grid item md={2}> */}
        {/*    <Typography variant={'body2'}>Amount expected</Typography> */}
        {/*    <Typography variant={'subtitle1'}> */}
        {/*      <strong>{project.crowdSale.totalSrcAmountExpected}</strong> */}
        {/*    </Typography> */}
        {/*  </Grid> */}
        {/*  <Grid item md={2}> */}
        {/*    <Typography variant={'body2'}>Cell owners</Typography> */}
        {/*    <Typography variant={'subtitle1'}> */}
        {/*      <strong>{project.crowdSale.countCellOwners}</strong> */}
        {/*    </Typography> */}
        {/*  </Grid> */}
        {/*  <Grid item md={2}> */}
        {/*    <Typography variant={'body2'}>Cell owner agreements</Typography> */}
        {/*    <Typography variant={'subtitle1'}> */}
        {/*      <strong>{project.crowdSale.countCurrentCellOwnerAgreements}</strong> */}
        {/*    </Typography> */}
        {/*  </Grid> */}
        {/* </Grid> */}
        <Box sx={{ p: 4, mt: 3 }}>
          {pendingAdhocDistributionsApiResult.isLoading && <LoadingComponent />}
          {(pendingAdhocDistributionsApiResult.error != null) && <ErrorComponent message={RtkQueryHelper.mapResponseError(pendingAdhocDistributionsApiResult.error)} />}
          { pendingAdhocDistributionsApiResult.isSuccess && (
            // <DataGrid
            //   getRowId={(row) => row.id}
            //   rows={pendingAdhocDistributionsApiResult.data.pendingDistributions}
            //   columns={pendingAdhocsGrids}
            //   autoHeight={true}
            //   rowCount={pendingAdhocDistributionsApiResult.data.pendingDistributions.length}
            //   paginationMode="server"
            //   pagination
            // />
            <MUIDataTable
              title = {'Pending adhocs'}
              data = { pendingAdhocDistributionsApiResult.data.pendingDistributions }
              columns = { pendingAdhocColumns }
              options = { options }>

            </MUIDataTable>
          )}
        </Box>
      </Paper>
    </>
  )
}

export default AdhocDistributionsPage
